/**
 * InputManager — unified input across keyboard, touch, and gamepad.
 *
 * Provides action-based input (e.g. "move", "action") rather than
 * raw key checks. Game code binds to actions, InputManager maps
 * from device inputs.
 */

declare const Phaser: any;

export interface InputState {
  left: boolean;
  right: boolean;
  up: boolean;
  down: boolean;
  action: boolean;
}

export class InputManager {
  private cursors: any;
  private actionKey: any;
  private _state: InputState = {
    left: false,
    right: false,
    up: false,
    down: false,
    action: false,
  };

  constructor(scene: any) {
    this.cursors = scene.input.keyboard.createCursorKeys();
    this.actionKey = scene.input.keyboard.addKey(
      Phaser.Input.Keyboard.KeyCodes.SPACE
    );
  }

  get state(): InputState {
    return this._state;
  }

  update(): void {
    this._state.left = this.cursors.left.isDown;
    this._state.right = this.cursors.right.isDown;
    this._state.up = this.cursors.up.isDown;
    this._state.down = this.cursors.down.isDown;
    this._state.action = Phaser.Input.Keyboard.JustDown(this.actionKey);
  }
}
